'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPropertyProduct = undefined;

var _createProperty = require('ui-addon-upgrades/_core/common/data/upgradeData/transformers/createProperty');

var _products = require('ui-addon-upgrades/_core/common/data/upgradeData/properties/products');

var PROPERTY_KEY = 'product';

/**
 * @param {Object} upgradeData
 * @param {String} upgradeSource
 * @return {Object}
 */

var getPropertyProduct = exports.getPropertyProduct = function getPropertyProduct(_ref) {
  var upgradeProduct = _ref.upgradeProduct;

  var propertyValue = _products.products[upgradeProduct];

  return (0, _createProperty.createProperty)(PROPERTY_KEY, propertyValue);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/common/data/upgradeData/transformers/getPropertyProduct.js
// module id = 445
// module chunks = 3 4 5